import { Box, Button, Card, Flex, Heading, Select, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { ALL_LEAD_STATUSES_VALUE } from '../leads-browser.store';
import { LeadStatus } from '../types';
import { useLeadsBrowser } from '../leads-browser.provider';

const STATUS_OPTIONS: Array<{ label: string; value: LeadStatus | typeof ALL_LEAD_STATUSES_VALUE }> =
   [
      { label: 'All statuses', value: ALL_LEAD_STATUSES_VALUE },
      { label: 'Pending', value: 'pending' },
      { label: 'Processed', value: 'processed' },
      { label: 'Failed', value: 'failed' },
   ];

const LeadsBrowserFiltersView = () => {
   const leadsStore = useLeadsBrowser();

   return (
      <Card m="3" className="leads-browser-filters">
         <Flex direction="column" gap="2" width="100%">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>

            <Flex gap="3" align="end" wrap="wrap">
               <Box minWidth="300px" width="100%" maxWidth="560px">
                  <TextField.Root
                     placeholder="Search by ID, Facebook Lead ID, Page ID or status"
                     size="3"
                     color="blue"
                     autoComplete="off"
                     value={leadsStore.searchStr}
                     onChange={(e) => {
                        leadsStore.onSearchChange(e.target.value);
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                           void leadsStore.submitSearch();
                        }
                     }}
                  />
               </Box>

               <Box minWidth="220px" width="220px">
                  <Select.Root
                     size="3"
                     value={leadsStore.selectedStatus}
                     onValueChange={(value) => {
                        leadsStore.onStatusChange(
                           value as LeadStatus | typeof ALL_LEAD_STATUSES_VALUE
                        );
                     }}
                  >
                     <Select.Trigger
                        color="blue"
                        placeholder="Select status"
                        style={{ width: '100%' }}
                     />
                     <Select.Content color="blue" position="popper">
                        {STATUS_OPTIONS.map((status) => (
                           <Select.Item key={status.value} value={status.value}>
                              {status.label}
                           </Select.Item>
                        ))}
                     </Select.Content>
                  </Select.Root>
               </Box>

               <Button
                  size="3"
                  loading={leadsStore.loading}
                  onClick={() => {
                     void leadsStore.submitSearch();
                  }}
               >
                  Search
               </Button>
            </Flex>
         </Flex>
      </Card>
   );
};

export const LeadsBrowserFilters = observer(LeadsBrowserFiltersView);
